import React from 'react';
import usePortfolioAnalytics from 'src/app/portfolio/views/portfolio-summary/hooks/usePortfolioAnalytics';
import ExploreButton, { ExploreButtonProps } from 'src/shared/components/explore-button/ExploreButton';

const PortfolioExploreButton = (props: ExploreButtonProps) => {
    const trackAnalytics = usePortfolioAnalytics();

    const handleExploreClick = () => {
        trackAnalytics.trackExploreClick({ section: props.sectionName || '' });
        props.onClick?.();
    };

    return <ExploreButton {...props} onClick={handleExploreClick} />;
};

export default PortfolioExploreButton;
